import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import TripsPage from "@/pages/TripsPage";
import TripPage from "@/pages/TripPage";
import IrlPage from "@/pages/IrlPage";
import LegalPage from "@/pages/LegalPage";
import FaqPage from "@/pages/FaqPage";
import SurveyPage from "@/pages/SurveyPage";
import ConsentPage from "@/pages/ConsentPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import { RoamieWidget } from "@/components/RoamieWidget";
import { WhatsAppHub } from "@/components/WhatsAppHub";

const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <RoamieWidget />
    <WhatsAppHub />
  </>
);

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
};

function App() {
  useLenis();
  return (
    <MotionConfig reducedMotion="user">
      <div className="App bg-cream text-ink font-sans min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/trips" element={<TripsPage />} />
            <Route path="/trips/:slug" element={<TripPage />} />
            <Route path="/irl" element={<IrlPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/survey" element={<SurveyPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/screening-consent/:token" element={<ConsentPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      </div>
    </MotionConfig>
  );
}

export default App;
